window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-ntk').forEach(ntk => {
    const button = ntk.querySelector('.product-ntk-more');

    if (button) {
      button.addEventListener('click', e => {
        e.preventDefault();

        button.remove();

        ntk.querySelectorAll('.product-ntk-item-more').forEach(item => {
          item.classList.remove('product-ntk-item-more');
        });
      });
    }
  });
});